
<div class="container-scroller">
  <!-- Header -->
  <app-dashboard-header></app-dashboard-header>
  <!-- Header -->

  <div class="container-fluid page-body-wrapper">
    <!-- Theam Color change Panal -->
    <div class="theme-setting-wrapper">
      <!-- <div id="settings-trigger"><i class="ti-settings"></i></div> -->
      <div id="theme-settings" class="settings-panel">
        <i class="settings-close ti-close"></i>
        <p class="settings-heading">SIDEBAR SKINS</p>
        <div class="sidebar-bg-options selected" id="sidebar-light-theme"><div class="img-ss rounded-circle bg-light border mr-3"></div>Light</div>
        <div class="sidebar-bg-options" id="sidebar-dark-theme"><div class="img-ss rounded-circle bg-dark border mr-3"></div>Dark</div>
        <p class="settings-heading mt-2">HEADER SKINS</p>
        <div class="color-tiles mx-0 px-4">
          <div class="tiles success"></div>
          <div class="tiles warning"></div>
          <div class="tiles danger"></div>
          <div class="tiles info"></div>
          <div class="tiles dark"></div>
          <div class="tiles default"></div>
        </div>
      </div>
    </div>
    <!-- Dashboard Sidebar Menu -->
    <app-dashboard-sidebarmenu></app-dashboard-sidebarmenu>
    <!-- Dashboard Sidebar Menu -->
    <div class="main-panel sidebar-full-main-panel-margin" id="main-panel-control">
      <router-outlet></router-outlet>
      <!-- Footer-->
      <app-footer></app-footer>
      <!-- Footer -->
    </div>
  </div>
</div>
